module.exports = __webpack_public_path__ + "static/img/icon_wuchuangshenjing_tiaokong_zhiliao.38ff08bd.png";